var _defs, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 683.84 370.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #383d84;\n      }\n\n      .cls-3 {\n        fill: #6265ce;\n      }\n\n      .cls-4 {\n        fill: #ffb552;\n      }\n\n      .cls-5 {\n        stroke: #d35d57;\n      }\n\n      .cls-5, .cls-6 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        stroke: #383d84;\n        stroke-width: 7px;\n      }\n\n      .cls-7 {\n        fill: #a9b3ff;\n      }\n\n      .cls-8 {\n        fill: #d35d57;\n      }\n\n      .cls-9 {\n        fill: #252a5e;\n      }\n\n      .cls-10 {\n        fill: #bf4340;\n      }\n\n      .cls-11 {\n        fill: #cdd7ff;\n      }\n\n      .cls-12 {\n        fill: #5fc5a9;\n      }\n\n      .cls-13 {\n        fill: #7b85e8;\n      }\n\n      .cls-14 {\n        fill: #4d52a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 457.54,
    y: 170.07,
    width: 145.1,
    height: 198.61,
    rx: 6.21,
    ry: 6.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 465.41,
    y: 176.52,
    width: 129.35,
    height: 184.34,
    rx: 5.98,
    ry: 5.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m564.9,163.44h-15.76c-.79-5.32-5.36-9.41-10.9-9.41h-2.34c.5-.93.81-1.98.81-3.11,0-3.66-2.97-6.63-6.63-6.63s-6.63,2.97-6.63,6.63c0,1.13.31,2.18.81,3.11h-2.34c-5.54,0-10.11,4.09-10.9,9.41h-15.76c-4.75,0-8.59,3.85-8.59,8.59v7.89h86.81v-7.89c0-4.75-3.85-8.59-8.59-8.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 512.3,
    y: 197.37,
    width: 72.22,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 512.3,
    y: 208.77,
    width: 72.22,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 512.3,
    y: 220.17,
    width: 72.22,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 197.37,
    width: 26.76,
    height: 26.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 239.75,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 251.74,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 263.73,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 275.72,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 287.71,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 299.7,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 311.7,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 323.69,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 335.68,
    width: 108.87,
    height: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 475.65,
    y: 347.67,
    width: 108.87,
    height: 3.96
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m127.89,232.72h35.04c5.22,0,9.45,4.23,9.45,9.45v12.51h-53.94v-12.51c0-5.22,4.23-9.45,9.45-9.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 58.61,
    y: 250.23,
    width: 173.6,
    height: 118.45,
    rx: 7.25,
    ry: 7.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.11,
    y: 248.95,
    width: 182.61,
    height: 66.67,
    rx: 6.13,
    ry: 6.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 84.33,
    y: 248.95,
    width: 12.83,
    height: 119.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 193.66,
    y: 248.95,
    width: 12.83,
    height: 119.73,
    transform: "translate(400.16 617.63) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.9,
    y: 265.72,
    width: 11.02,
    height: 33.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.9,
    y: 265.72,
    width: 11.02,
    height: 33.13,
    transform: "translate(427.7 136.87) rotate(90)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m484.74,193.71h0c1.96-7.42,3.02-15.21,3.02-23.24,0-50.02-40.55-90.57-90.57-90.57-30.17,0-56.88,14.77-73.34,37.45-16.46-22.69-43.17-37.45-73.34-37.45-50.02,0-90.57,40.55-90.57,90.57,0,8.04,1.06,15.82,3.02,23.24h0c.09.33.2.66.29.99.3,1.07.6,2.13.93,3.18,31.99,105.64,159.68,172.13,159.68,172.13,0,0,127.68-66.48,159.68-172.12.33-1.05.64-2.12.93-3.19.09-.33.2-.65.29-.98Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m367.04,342.6c-.13-.56-.28-1.12-.46-1.67-1.9-5.83-7.23-11.04-13.35-10.69-6.02.34-11.39,5.77-17.27,4.45-4.69-1.06-7.46-6.21-7.62-11.02-.16-4.81,1.63-9.43,2.97-14.05,1.86-6.43,2.88-13.29,1.39-19.81-1.49-6.52-5.86-12.66-12.16-14.91-13.41-4.8-27.43,9.04-41.44,6.51-6.67-1.21-12.05-5.92-17.78-9.54-9.53-6.04-21.03-9.34-32.22-7.92-8.29,1.05-16.32,4.9-22.1,10.86,49.16,59.95,116.85,95.2,116.85,95.2,0,0,18.51-9.65,43.2-27.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m164.7,141.39c1.9.39,3.85.55,5.81.44,7.43-.41,14.29-4,21.56-5.56s16.25-.25,19.83,6.28c2.6,4.74,1.39,10.83-1.54,15.38s-7.3,7.93-11.47,11.37c-7.84,6.46-15.61,14-18.13,23.84-2.52,9.84,2.54,22.23,12.52,24.13,5.81,1.1,11.64-1.44,17.53-1.91,8.72-.69,17.17,3.19,24.46,8.01s13.93,10.67,21.67,14.73c7.75,4.06,17.14,6.16,25.24,2.88,8.11-3.28,13.68-13.31,9.92-21.2-3.2-6.71-11.15-9.34-18.12-11.92-6.97-2.58-14.67-6.98-15.48-14.37-.97-8.89,8.59-15.1,17.12-17.79,8.53-2.69,18.56-5.01,22.52-13.03,4.21-8.49-.98-18.72-7.53-25.56-6.56-6.85-14.81-12.55-18.62-21.23-3.68-8.39-2.52-18.06-4.45-27.02-.58-2.71-1.7-5.46-3.21-7.92-4.51-.69-9.13-1.05-13.83-1.05-39.85,0-73.69,25.73-85.8,61.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m420.78,272.54c-.5-9.42-9.18-16.77-10.15-26.16-1.51-14.69,16.14-26.56,13.76-41.13-1.65-10.11-13.31-16.37-23.42-14.71-10.11,1.66-18.33,9.32-23.74,18.02-4.73,7.61-8.37,16.79-16.39,20.77-7.38,3.67-17.6,2.4-22.54,8.99-3.5,4.66-2.58,11.18-1.32,16.87,1.49,6.72,3.3,13.53,7.06,19.3,3.69,5.67,10.73,11.9,17.95,10.28,8.02-1.79,12.8-7.59,21.83-4.71,6.51,2.08,11.73,7.5,18.45,8.73,9.29,1.71,19.01-6.83,18.51-16.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m484.45,194.69c.09-.33.2-.65.29-.98h0c1.96-7.42,3.02-15.21,3.02-23.24,0-2.07-.08-4.12-.21-6.16-3.18-2.09-6.56-3.84-10.17-5.06-9.14-3.1-19.92-2.46-27.59,3.39s-11.05,17.43-6.15,25.74c2.26,3.84,5.9,6.63,8.99,9.84,3.09,3.21,5.79,7.35,5.37,11.78-.66,6.97-8.28,10.91-11.76,16.98-4.24,7.39-1.57,17.2,4.03,23.62,1.53,1.75,3.24,3.3,5.06,4.71,11.95-17.5,21.92-36.71,28.2-57.44.33-1.05.64-2.12.93-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m338.41,175.03c2.96,4.58,8.02,7.49,13.3,8.86,19.45,5.04,31.88-5.47,40.23-22.33,6.56-13.26,15.25-43.25,33.98-24.5,4.65,4.65,11.83,8.26,18.74,6.41,8.41-2.26,12.11-11.67,15.82-18.64,2.07-3.88,4.4-7.78,7.54-10.8-16.6-20.8-42.15-34.12-70.83-34.12-25.82,0-49.09,10.82-65.58,28.15,3.62,7.88,8.21,20.2,8.46,21.93,2.09,14.73-10.65,31.14-1.65,45.06Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m332.48,187.14h-17.28c-12.24,0-22.82-8.3-25.73-20.19l-21.24-86.69c-.8-3.27-.07-6.67,2.01-9.32,2.08-2.65,5.2-4.17,8.57-4.17h5.01c1.09,0,1.98.89,1.98,1.98s-.89,1.98-1.98,1.98h-5.01c-2.14,0-4.13.97-5.45,2.65s-1.79,3.84-1.28,5.93l21.24,86.69c2.48,10.11,11.47,17.16,21.88,17.16h17.28c10.4,0,19.4-7.06,21.88-17.16l21.24-86.69c.51-2.08.04-4.24-1.28-5.92-1.32-1.69-3.31-2.65-5.45-2.65h-5.01c-1.1,0-1.98-.89-1.98-1.98s.89-1.98,1.98-1.98h5.01c3.37,0,6.49,1.52,8.57,4.17,2.08,2.65,2.81,6.05,2.01,9.32l-21.24,86.69c-2.91,11.89-13.49,20.19-25.73,20.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m332.48,189.12h-17.28c-13.15,0-24.53-8.92-27.66-21.7-.52-2.13.78-4.27,2.91-4.8,2.13-.52,4.27.78,4.8,2.91,2.26,9.22,10.46,15.65,19.95,15.65h17.28c9.49,0,17.69-6.44,19.95-15.65.52-2.13,2.67-3.43,4.8-2.91,2.13.52,3.43,2.67,2.91,4.8-3.13,12.77-14.5,21.7-27.66,21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m292.31,62.25c-2.25,0-4.24,1.14-5.41,2.88-.72-.31-1.53-.51-2.41-.51-2.83,0-5.12,1.85-5.12,4.14s2.29,4.14,5.12,4.14c.88,0,1.69-.19,2.41-.51,1.17,1.74,3.15,2.88,5.41,2.88,3.6,0,3.88-2.92,3.88-6.51s-.28-6.51-3.88-6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m355.38,62.25c2.25,0,4.24,1.14,5.41,2.88.72-.31,1.53-.51,2.41-.51,2.83,0,5.12,1.85,5.12,4.14s-2.29,4.14-5.12,4.14c-.88,0-1.69-.19-2.41-.51-1.17,1.74-3.15,2.88-5.41,2.88-3.6,0-3.88-2.92-3.88-6.51s.28-6.51,3.88-6.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m452.6,209.25h-114.4c-5.73,0-10.39-4.66-10.39-10.39v-13.7c0-2.19-1.78-3.97-3.97-3.97s-3.97,1.78-3.97,3.97v13.7c0,10.1,8.22,18.32,18.32,18.32h114.4c14.06,0,25.5,11.44,25.5,25.5s-11.44,25.5-25.5,25.5h-6.65c-2.08,2.69-4.2,5.33-6.35,7.93h13c18.44,0,33.43-15,33.43-33.43s-15-33.43-33.43-33.43Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m323.84,255.16c-2.19,0-3.97,1.78-3.97,3.97v23.68c0,8.46-6.89,15.35-15.35,15.35h-94.84c-6.08,0-11.02-4.94-11.02-11.02,0-5.57,4.16-10.17,9.52-10.9-1.83-2.21-3.64-4.44-5.42-6.72-7.03,2.77-12.03,9.62-12.03,17.62,0,10.45,8.5,18.95,18.95,18.95h94.84c12.84,0,23.28-10.44,23.28-23.28v-23.68c0-2.19-1.78-3.97-3.97-3.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 323.84,
    cy: 252.8,
    r: 25.74,
    transform: "translate(-83.9 303.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 323.84,
    cy: 252.8,
    r: 16.19,
    transform: "translate(22.21 531.72) rotate(-80.74)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 338.71,
    y: 268.21,
    width: 58.46,
    height: 100.47,
    rx: 5.05,
    ry: 5.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 334.6,
    y: 247.88,
    width: 66.69,
    height: 25.21,
    rx: 1.98,
    ry: 1.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 367.24,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 363.83,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 360.41,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 356.99,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 353.58,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 350.16,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 346.75,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 343.33,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 339.92,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 336.5,
    y: 250.14,
    width: 1.4,
    height: 20.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 370.66,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(742.72 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 374.07,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(749.55 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 377.49,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(756.38 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 380.9,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(763.21 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384.32,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(770.04 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 387.74,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(776.87 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 391.15,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(783.71 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 394.57,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(790.54 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 397.98,
    y: 250.14,
    width: 1.4,
    height: 20.69,
    transform: "translate(797.37 520.98) rotate(180)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 365.23,
    y: 287.8,
    width: 31.95,
    height: 8.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 365.23,
    y: 307.47,
    width: 31.95,
    height: 46.27
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m445.28,291.62v-6.84h-16.04v6.84c0,2.75-1.66,5.23-4.2,6.28l-4.2,1.73c-4.2,1.73-6.95,5.83-6.95,10.37v49.79c0,4.92,3.99,8.9,8.9,8.9h28.93c4.92,0,8.9-3.99,8.9-8.9v-49.79c0-4.55-2.74-8.64-6.95-10.37l-4.2-1.73c-2.54-1.05-4.2-3.53-4.2-6.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 413.9,
    y: 312.34,
    width: 46.73,
    height: 42.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 431.25,
    y: 317.79,
    width: 29.38,
    height: 5.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 431.25,
    y: 329.54,
    width: 29.38,
    height: 20.19
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 424.76,
    y: 276.77,
    width: 25.01,
    height: 12.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 436.49,
    y: 278.02,
    width: 1.55,
    height: 10.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 433.09,
    y: 278.02,
    width: 1.55,
    height: 10.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 429.69,
    y: 278.02,
    width: 1.55,
    height: 10.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 426.3,
    y: 278.02,
    width: 1.55,
    height: 10.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 439.89,
    y: 278.02,
    width: 1.55,
    height: 10.42,
    transform: "translate(881.33 566.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 443.28,
    y: 278.02,
    width: 1.55,
    height: 10.42,
    transform: "translate(888.12 566.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 446.68,
    y: 278.02,
    width: 1.55,
    height: 10.42,
    transform: "translate(894.92 566.46) rotate(180)"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m309.07,24.54l-13.65,13.65c-2.28,2.28-5.98,2.28-8.26,0h0c-2.28-2.28-2.28-5.98,0-8.26l13.65-13.65c2.28-2.28,5.98-2.28,8.26,0h0c2.28,2.28,2.28,5.98,0,8.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m300.8,16.28l-6.83,6.83,8.26,8.26,6.83-6.83c2.28-2.28,2.28-5.98,0-8.26s-5.98-2.28-8.26,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m663.21,308.09l14.36,12.91c2.4,2.16,2.6,5.85.44,8.25h0c-2.16,2.4-5.85,2.6-8.25.44l-14.36-12.91c-2.4-2.16-2.6-5.85-.44-8.25h0c2.16-2.4,5.85-2.6,8.25-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m655.4,316.78l7.18,6.45,7.81-8.69-7.18-6.45c-2.4-2.16-6.1-1.96-8.25.44-2.16,2.4-1.96,6.1.44,8.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.98,92.98v-14.9c0-2.49,2.02-4.51,4.51-4.51h0c2.49,0,4.51,2.02,4.51,4.51v14.9c0,2.49-2.02,4.51-4.51,4.51h0c-2.49,0-4.51-2.02-4.51-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.99,92.98v-7.45h-9.02v7.45c0,2.49,2.02,4.51,4.51,4.51s4.51-2.02,4.51-4.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m653.99,331.17v12.97c0,2.17-1.76,3.93-3.93,3.93h0c-2.17,0-3.93-1.76-3.93-3.93v-12.97c0-2.17,1.76-3.93,3.93-3.93h0c2.17,0,3.93,1.76,3.93,3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m646.13,331.17v6.49h7.85v-6.49c0-2.17-1.76-3.93-3.93-3.93s-3.93,1.76-3.93,3.93Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m35.62,194.34l-10.24-10.24c-1.71-1.71-1.71-4.49,0-6.2h0c1.71-1.71,4.49-1.71,6.2,0l10.24,10.24c1.71,1.71,1.71,4.49,0,6.2h0c-1.71,1.71-4.49,1.71-6.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.82,188.14l-5.12-5.12-6.2,6.2,5.12,5.12c1.71,1.71,4.49,1.71,6.2,0,1.71-1.71,1.71-4.49,0-6.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m626.49,126.3l-10.24,10.24c-1.71,1.71-4.49,1.71-6.2,0h0c-1.71-1.71-1.71-4.49,0-6.2l10.24-10.24c1.71-1.71,4.49-1.71,6.2,0h0c1.71,1.71,1.71,4.49,0,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m620.3,120.1l-5.12,5.12,6.2,6.2,5.12-5.12c1.71-1.71,1.71-4.49,0-6.2-1.71-1.71-4.49-1.71-6.2,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m188.53,50.07h0c.26-1,.4-2.04.39-3.13-.08-6.21-5.15-11.33-11.36-11.45-3.96-.08-7.49,1.83-9.64,4.8-2.15-2.97-5.67-4.88-9.64-4.8-6.21.13-11.28,5.24-11.36,11.45-.01,1.08.12,2.13.39,3.13h0s.03.08.04.13c.04.14.08.27.12.41,3.15,10.4,13.54,17.84,18.18,20.72,1.39.87,3.16.87,4.55,0,4.64-2.89,15.03-10.32,18.18-20.72.04-.14.08-.27.12-.41.01-.04.03-.08.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.62,279.96h0c.11-.43.17-.89.17-1.36-.03-2.71-2.24-4.93-4.95-4.99-1.73-.04-3.26.8-4.2,2.09-.94-1.29-2.47-2.12-4.2-2.09-2.71.06-4.91,2.28-4.95,4.99,0,.47.05.93.17,1.36h0s.01.04.02.06c.02.06.03.12.05.18,1.37,4.53,5.9,7.77,7.92,9.02.61.38,1.37.38,1.98,0,2.02-1.26,6.54-4.5,7.92-9.02.02-.06.04-.12.05-.18,0-.02.01-.04.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m683.11,208.55h0c.16-.6.24-1.22.23-1.87-.05-3.72-3.08-6.79-6.81-6.86-2.38-.05-4.48,1.1-5.77,2.87-1.29-1.78-3.4-2.92-5.77-2.87-3.72.08-6.76,3.14-6.81,6.86,0,.65.07,1.28.23,1.87h0s.02.05.02.08c.02.08.05.16.07.24,1.89,6.23,8.11,10.69,10.89,12.42.84.52,1.89.52,2.73,0,2.78-1.73,9.01-6.19,10.89-12.42.03-.08.05-.16.07-.25,0-.03.01-.05.02-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "441.34 127.99 434.71 127.99 434.71 121.37 428.1 121.37 428.1 127.99 421.48 127.99 421.48 134.6 428.1 134.6 428.1 141.23 434.71 141.23 434.71 134.6 441.34 134.6 441.34 127.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196 171.15 186.63 171.15 186.63 161.78 177.28 161.78 177.28 171.15 167.91 171.15 167.91 180.49 177.28 180.49 177.28 189.86 186.63 189.86 186.63 180.49 196 180.49 196 171.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "476.51 94.6 465.91 94.6 465.91 84 455.35 84 455.35 94.6 444.75 94.6 444.75 105.17 455.35 105.17 455.35 115.76 465.91 115.76 465.91 105.17 476.51 105.17 476.51 94.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "358.4 7.58 350.82 7.58 350.82 0 343.26 0 343.26 7.58 335.69 7.58 335.69 15.13 343.26 15.13 343.26 22.71 350.82 22.71 350.82 15.13 358.4 15.13 358.4 7.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "584.52 64.24 571.04 64.24 571.04 50.77 557.61 50.77 557.61 64.24 544.13 64.24 544.13 77.68 557.61 77.68 557.61 91.15 571.04 91.15 571.04 77.68 584.52 77.68 584.52 64.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "39.52 220.01 31.21 220.01 31.21 211.71 22.93 211.71 22.93 220.01 14.62 220.01 14.62 228.3 22.93 228.3 22.93 236.6 31.21 236.6 31.21 228.3 39.52 228.3 39.52 220.01"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.8b429b144a5380aa3dd55f23a2133265.svg";
export { ForwardRef as ReactComponent };